/* @flow */

import React from 'react';
import {connect} from 'react-redux';
import Mouse from './Mouse';
import BillPrintOff from './BillPrintOff';
import ChangeOffer from './ChangeOffer';
import PaymentSelect from './PaymentSelect';
import SilentPrint from './SilentPrint';
import DeviceName from './DeviceName';
import KitchenPrint from './KitchenPrint';
import KitchenPrintItemStyle from './KitchenPrintItemStyle';
import SendLocalestorage from './SendLocalestorage';
import KitchenPrintTest from './KitchenPrintTest';
import PrintTest from './PrintTest';
import SelectKitchenPrint from './SelectKitchenPrint';
import FullScreen from './FullScreen';
import PrintType from './PrintType';
import LoginByPin from './LoginByPin';
import Language from './Language';
import Homepage from './Homepage';
import PinLockTimeout from './PinLockTimeout';
import Popup from '../popup/Popup';
import {dashedToCamelCase, getNameByLang, isEnv} from '../../../common/lib/util';
import {chooseOffer} from '../../../common/offers/actions';
import {doNonUserWithPinError, showPopupInMenu} from '../../../common/menu/actions';
import {fetchOnlyCategories} from '../../../common/categories/actions';
import {changeDeviceSettings, setDeviceName} from '../../../common/device/actions';
import KeyboardPopup from '../../components/keyboard/KeyboardPopup';
import NumericalKeyboard from '../../components/keyboard/Numerical';

const TAB_SELL = 'TAB_SELL';
const TAB_PRINT = 'TAB_PRINT';
const TAB_SYSTEM = 'TAB_SYSTEM';

class Settings extends React.Component {

    state: State = {
        printTypeState: this.props.printType,
        printPopupOpenedKeyboard: false,
        printPopupOpened: false,
        printNumKeyboardOpen: false,
        kitchenPrintTypeState: this.props.kitchenPrintType,
        kitchenPrintPopupOpenedKeyboard: false,
        kitchenPrintPopupOpened: false,
        kitchenPrintNumKeyboardOpen: false,
        deviceNameKeyboardOpen: false,
        pinPopupOpened: false,
        settingTab: TAB_SELL,
        printAddress: this.props.currentPrintAddress,
        kitchenPrintAddress: this.props.currentKitchenPrintAddress,
    };

    static propTypes = {
        msg: React.PropTypes.object,
        setDeviceName: React.PropTypes.func,
        changeDeviceSettings: React.PropTypes.func,
        doNonUserWithPinError: React.PropTypes.func,
        logoutTimerOptions: React.PropTypes.object,
        printTypeOptions: React.PropTypes.object,
        kitchenPrintTypeOptions: React.PropTypes.object,
        showPopupInMenu: React.PropTypes.func,
        offers: React.PropTypes.object,
        chooseOffer: React.PropTypes.func,
        showButtonLock: React.PropTypes.bool,
        bar: React.PropTypes.object,
        printType: React.PropTypes.string,
        deviceName: React.PropTypes.string,
        kitchenPrintType: React.PropTypes.string,
        deviceId: React.PropTypes.number,
        printLength: React.PropTypes.number,
        kitchenPrintLength: React.PropTypes.number,
        currentPrintAddress: React.PropTypes.string,
        currentKitchenPrintAddress: React.PropTypes.string
    };

    constructor(props) {
        super(props);

        this.updateCategories = this.updateCategories.bind(this);
        this.renderPopup = this.renderPopup.bind(this);
        this.openPinChoosePopup = this.openPinChoosePopup.bind(this);
        this.openPrintTypePopup = this.openPrintTypePopup.bind(this);
        this.openKitchenPrintTypePopup = this.openKitchenPrintTypePopup.bind(this);
        this.closeKitchenPrintChoosePopup = this.closeKitchenPrintChoosePopup.bind(this);
        this.closePinChoosePopup = this.closePinChoosePopup.bind(this);
        this.renderPinSelect = this.renderPinSelect.bind(this);
        this.selectTimeout = this.selectTimeout.bind(this);
        this.closePrintChoosePopup = this.closePrintChoosePopup.bind(this);
        this.renderPrintSelect = this.renderPrintSelect.bind(this);
        this.selectPrintType = this.selectPrintType.bind(this);
        this.closePrintKeyboard = this.closePrintKeyboard.bind(this);
        this.submitPrintKeyboard = this.submitPrintKeyboard.bind(this);
        this.renderKitchenPrintSelect = this.renderKitchenPrintSelect.bind(this);
        this.selectKitchenPrintType = this.selectKitchenPrintType.bind(this);
        this.closeKitchenPrintKeyboard = this.closeKitchenPrintKeyboard.bind(this);
        this.submitKitchenPrintKeyboard = this.submitKitchenPrintKeyboard.bind(this);
        this.savePrintKeyboardVal = this.savePrintKeyboardVal.bind(this);
        this.saveKitchenPrintKeyboardVal = this.saveKitchenPrintKeyboardVal.bind(this);
        this.submitDeviceNameKeyboardOpen = this.submitDeviceNameKeyboardOpen.bind(this);
        this.openDeviceNameKeyboardOpen = this.openDeviceNameKeyboardOpen.bind(this);
        this.closeDeviceNameKeyboardOpen = this.closeDeviceNameKeyboardOpen.bind(this);
        this.getPrintLabelByType = this.getPrintLabelByType.bind(this);
    }

    submitDeviceNameKeyboardOpen(name) {
        const {changeDeviceSettings, setDeviceName, deviceId} = this.props;
        changeDeviceSettings('name', name);
        setDeviceName({id: deviceId, name});
        this.closeDeviceNameKeyboardOpen();
    }

    openDeviceNameKeyboardOpen() {
        this.setState({deviceNameKeyboardOpen: true});
    }

    closeDeviceNameKeyboardOpen() {
        this.setState({deviceNameKeyboardOpen: false});
    }

    updateCategories(offerId) {
        const {chooseOffer, fetchOnlyCategories, bar, showPopupInMenu, deviceId} = this.props;
        chooseOffer(offerId);
        fetchOnlyCategories(bar.get('id'), deviceId);
        showPopupInMenu(false);
    }

    openPrintTypePopup() {
        this.setState({printPopupOpened: true});
    }

    openKitchenPrintTypePopup() {
        this.setState({kitchenPrintPopupOpened: true});
    }

    openPinChoosePopup() {
        const {showButtonLock, doNonUserWithPinError} = this.props;
        if (showButtonLock) {
            this.setState({pinPopupOpened: true});
        } else {
            doNonUserWithPinError();
            this.setState({pinPopupOpened: true});
            this.selectTimeout(null);
        }
    }

    closePrintChoosePopup() {
        this.setState({printPopupOpened: false});
    }

    closeKitchenPrintChoosePopup() {
        this.setState({kitchenPrintPopupOpened: false});
    }

    closePinChoosePopup() {
        this.setState({pinPopupOpened: false});
    }

    selectTimeout(key) {
        const {changeDeviceSettings} = this.props;
        changeDeviceSettings('logoutTimer', key);
        this.closePinChoosePopup();
    }

    selectKitchenPrintType(key) {
        const {changeDeviceSettings} = this.props;
        const {kitchenPrintTypeState} = this.state;

        // Do not remember address if the print type has changed
        if(kitchenPrintTypeState !== key) {
            this.setState({kitchenPrintAddress: ''});
        }
        this.closeKitchenPrintChoosePopup();
        if (['escpos-serial', 'escpos-net', 'escpos-bt'].indexOf(key) > -1) {
            this.setState({kitchenPrintTypeState: key, kitchenPrintPopupOpenedKeyboard: true});
        } else if (['escpos-usb'].indexOf(key) > -1) {
            this.setState({kitchenPrintTypeState: key, kitchenPrintNumKeyboardOpen: true});
        } else {
            changeDeviceSettings('kitchenPrintType', key);
        }
    }

    closeKitchenPrintKeyboard() {
        this.setState({kitchenPrintPopupOpenedKeyboard: false});
    }

    saveKitchenPrintKeyboardVal(val) {
        const {changeDeviceSettings} = this.props;
        const {kitchenPrintTypeState} = this.state;
        this.closeKitchenPrintKeyboard();
        if (val === '') {
            changeDeviceSettings('kitchenPrintType', 'off');
        } else {
            if (kitchenPrintTypeState === 'escpos-net' && val.indexOf(':') === -1) {
                val += ':9100';
            }
            this.setState({
                kitchenPrintAddress: val,
                kitchenPrintNumKeyboardOpen: true
            });
        }
    }

    submitKitchenPrintKeyboard(val = 48) {
        const {changeDeviceSettings} = this.props;
        const {kitchenPrintTypeState, kitchenPrintAddress} = this.state;

        this.setState({'kitchenPrintNumKeyboardOpen': false});

        changeDeviceSettings('kitchenPrintType', kitchenPrintTypeState);
        changeDeviceSettings('kitchenPrintAddress', kitchenPrintAddress);
        if (val === '') {
            changeDeviceSettings('kitchenPrintLength', 48);
        } else if (val > 64) {
            changeDeviceSettings('kitchenPrintLength', 64);
        } else if (val < 24) {
            changeDeviceSettings('kitchenPrintLength', 24);
        } else {
            changeDeviceSettings('kitchenPrintLength', val);
        }
    }

    renderKitchenPrintSelect(printTypeOptions, printType) {
        const { msg } = this.props;
        let allowedTypes = typeof window.parent.Ocellot !== 'undefined' ? window.parent.Ocellot.getPrintTypes() : [];
        if (typeof allowedTypes === 'string') {
            allowedTypes = JSON.parse(allowedTypes);
        }
        allowedTypes.push('off');

        return (
            <div className="popup-inner">
                <h1 className="popup-title">{msg.settings.printType.kitchenTitle}</h1>
                <div className="popup-list">
                    {!!printTypeOptions && printTypeOptions.map((option, key) => {
                        if (allowedTypes.indexOf(key) === -1) {
                            return null;
                        }
                        if (printType === 'default' && key === 'default') {
                            return null;
                        }
                        return (
                            <div className="popup-list-key">
                                <div className="boxBtn color-white"
                                     onClick={() => this.selectKitchenPrintType(key)}
                                     key={`printTypeOption-${key}`}>
                                    <div className="boxBtn-inner">
                                        <span>{msg.settings.printType[dashedToCamelCase(key)]}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    selectPrintType(key) {
        const {changeDeviceSettings} = this.props;
        const {printTypeState} = this.state;

        // Do not remember address if the print type has changed
        if(printTypeState !== key) {
            this.setState({printAddress: ''});
        }
        this.closePrintChoosePopup();
        if (['escpos-serial', 'escpos-net', 'escpos-bt'].indexOf(key) > -1) {
            this.setState({printTypeState: key, printPopupOpenedKeyboard: true});
        } else if (['escpos-usb'].indexOf(key) > -1) {
            this.setState({printTypeState: key, printNumKeyboardOpen: true});
        } else {
            changeDeviceSettings('printType', key);
        }
    }

    closePrintKeyboard() {
        this.setState({printPopupOpenedKeyboard: false});
    }

    savePrintKeyboardVal(val) {
        const {changeDeviceSettings} = this.props;
        const {printTypeState} = this.state;
        this.closePrintKeyboard();
        if (val === '') {
            changeDeviceSettings('printType', 'off');
        } else {
            if (printTypeState === 'escpos-net' && val.indexOf(':') === -1) {
                val += ':9100';
            }
            this.setState({
                printAddress: val,
                printNumKeyboardOpen: true
            });
        }
    }

    submitPrintKeyboard(val = 48) {
        const {changeDeviceSettings} = this.props;
        const {printTypeState, printAddress} = this.state;

        this.setState({'printNumKeyboardOpen': false});

        changeDeviceSettings('printType', printTypeState);
        changeDeviceSettings('printAddress', printAddress);
        if (val === '') {
            changeDeviceSettings('printLength', 48);
        } else if (val > 64) {
            changeDeviceSettings('printLength', 64);
        } else if (val < 24) {
            changeDeviceSettings('printLength', 24);
        } else {
            changeDeviceSettings('printLength', val);
        }
    }

    renderPrintSelect(printTypeOptions, kitchenPrintType) {
        let allowedTypes = typeof window.parent.Ocellot !== 'undefined' ? window.parent.Ocellot.getPrintTypes() : [];
        if (typeof allowedTypes === 'string') {
            allowedTypes = JSON.parse(allowedTypes);
        }
        allowedTypes.push('off');

        const {msg} = this.props;

        return (
            <div className="popup-inner">
                <h1 className="popup-title">{msg.settings.printType.title}</h1>
                <div className="popup-list">
                    {!!printTypeOptions && printTypeOptions.map((option, key) => {
                        if (allowedTypes.indexOf(key) === -1) {
                            return null;
                        }
                        if (kitchenPrintType === 'default' && key === 'default') {
                            return null;
                        }
                        return (
                            <div className="popup-list-key">
                                <div className="boxBtn color-white"
                                     onClick={() => this.selectPrintType(key)}
                                     key={`printTypeOption-${key}`}>
                                    <div className="boxBtn-inner">
                                <span>
                                    {msg.settings.printType[dashedToCamelCase(key)]}
                                </span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    renderPinSelect(logoutTimerOptions) {
        const {msg} = this.props;
        return (
            <div className="popup-inner">
                <h1 className="popup-title">{msg.settings.lockTime}</h1>
                <div className="popup-list">
                    <div className="popup-list-key">
                        <div className="boxBtn color-white"
                             onClick={() => this.selectTimeout(null)}>
                            <div className="boxBtn-inner">
                            <span>
                                {msg.settings.disable}
                            </span>
                            </div>
                        </div>
                    </div>
                    {!!logoutTimerOptions && logoutTimerOptions.map((option, key) =>
                        <div className="popup-list-key" key={`logoutTimerOptions-${key}`}>
                            <div className="boxBtn color-white"
                                 onClick={() => this.selectTimeout(key)}>
                                <div className="boxBtn-inner">
                                <span>
                                    {option}
                                </span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderPopup(offers) {
        const {msg} = this.props;
        return (
            <div className="popup-inner">
                <h1 className="popup-title">{msg.settings.selectOffer}</h1>
                <div className="popup-list">
                    {!!offers && offers.map(offer =>
                        <div className="popup-list-key" key={`offer-${offer.get('id')}`}>
                            <div className="boxBtn color-white"
                                 onClick={() => this.updateCategories(offer.get('id'))}>
                                <div className="boxBtn-inner">
                                <span>
                                    {getNameByLang(offer)}
                                </span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    getPrintLabelByType(type) {
        const { msg } = this.props;
        switch (type) {
            case 'escpos-net':
                return msg.settings.print.ipOrHost;
            case 'escpos-bt':
                return msg.settings.print.bt;
            default:
                return msg.settings.print.device;
        }
    }

    render() {
        const {
            offers, logoutTimerOptions, printTypeOptions, printType, kitchenPrintType, kitchenPrintTypeOptions,
            kitchenPrintLength, printLength, msg, deviceName
        } = this.props;

        const {
            pinPopupOpened, settingTab, printPopupOpened, printTypeState, printPopupOpenedKeyboard, printNumKeyboardOpen,
            kitchenPrintPopupOpened, kitchenPrintPopupOpenedKeyboard, kitchenPrintTypeState, kitchenPrintNumKeyboardOpen,
            deviceNameKeyboardOpen, printAddress, kitchenPrintAddress
        } = this.state;

        let printPopupOpenedKeyboardLabel = this.getPrintLabelByType(printTypeState);

        let kitchenPrintPopupOpenedKeyboardLabel = this.getPrintLabelByType(kitchenPrintTypeState);

        return (
            <div className="menuPage">
                <div className="menuPage-header">
                    <div className="menuPage-header-title" style={{width: `${isEnv(['android_app', 'electron']) ? '70' : '80'}%`}}>
                        <div className="menuPage-title">
                        <span>
                            {msg.settings.title}
                        </span>
                        </div>
                    </div>

                    <div className="menuPage-header-key" style={{width: '10%'}}>
                        <div className={`boxBtn color-${settingTab === TAB_SELL ? 'green' : 'white'}`}
                             onClick={() => this.setState({settingTab: TAB_SELL})}>
                            <div className="boxBtn-inner">
                                {msg.settings.tabs.sell}
                            </div>
                        </div>
                    </div>
                    {isEnv(['android_app', 'electron']) &&
                    <div className="menuPage-header-key" style={{width: '10%'}}>
                        <div className={`boxBtn color-${settingTab === TAB_PRINT ? 'green' : 'white'}`}
                             onClick={() => this.setState({settingTab: TAB_PRINT})}>
                            <div className="boxBtn-inner">
                                {msg.settings.tabs.print}
                            </div>
                        </div>
                    </div>
                    }
                    <div className="menuPage-header-key" style={{width: '10%'}}>
                        <div className={`boxBtn color-${settingTab === TAB_SYSTEM ? 'green' : 'white'}`}
                             onClick={() => this.setState({settingTab: TAB_SYSTEM})}>
                            <div className="boxBtn-inner">
                                {msg.settings.tabs.system}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="menuPage-content">

                    <Popup body={this.renderPopup(offers)}/>
                    {pinPopupOpened &&
                    <Popup body={this.renderPinSelect(logoutTimerOptions)}
                           disabledReducer
                           hideArrows
                           onClose={this.closePinChoosePopup}/>
                    }
                    {printPopupOpened && isEnv(['electron', 'android_app']) && typeof window.parent.Ocellot !== 'undefined' &&
                    <Popup body={this.renderPrintSelect(printTypeOptions, kitchenPrintType)}
                           disabledReducer
                           hideArrows
                           onClose={this.closePrintChoosePopup}/>
                    }
                    {printPopupOpenedKeyboard && isEnv(['electron', 'android_app']) && typeof window.parent.Ocellot !== 'undefined' &&
                    <KeyboardPopup defaultValue={printAddress}
                                   label={printPopupOpenedKeyboardLabel}
                                   onClose={this.closePrintKeyboard}
                                   onSubmit={this.savePrintKeyboardVal}/>
                    }
                    {printNumKeyboardOpen && isEnv(['electron', 'android_app']) && typeof window.parent.Ocellot !== 'undefined' &&
                    <NumericalKeyboard defaultValue={printLength}
                                       onClose={this.submitPrintKeyboard}
                                       onSubmit={this.submitPrintKeyboard}
                                       label={msg.settings.print.lineLength}
                                       nonDecimal/>
                    }

                    {kitchenPrintPopupOpened && isEnv(['electron', 'android_app']) && typeof window.parent.Ocellot !== 'undefined' &&
                    <Popup body={this.renderKitchenPrintSelect(kitchenPrintTypeOptions, printType)}
                           disabledReducer
                           hideArrows
                           onClose={this.closeKitchenPrintChoosePopup}/>
                    }
                    {kitchenPrintPopupOpenedKeyboard && isEnv(['electron', 'android_app']) && typeof window.parent.Ocellot !== 'undefined' &&
                    <KeyboardPopup defaultValue={kitchenPrintAddress}
                                   label={kitchenPrintPopupOpenedKeyboardLabel}
                                   onClose={this.closeKitchenPrintKeyboard}
                                   onSubmit={this.saveKitchenPrintKeyboardVal}/>
                    }
                    {kitchenPrintNumKeyboardOpen && isEnv(['electron', 'android_app']) && typeof window.parent.Ocellot !== 'undefined' &&
                    <NumericalKeyboard defaultValue={kitchenPrintLength}
                                       onClose={this.submitKitchenPrintKeyboard}
                                       onSubmit={this.submitKitchenPrintKeyboard}
                                       label={msg.settings.print.lineLength}
                                       nonDecimal/>
                    }
                    {deviceNameKeyboardOpen &&
                    <KeyboardPopup defaultValue={deviceName}
                                   validationReqex={`^.{3,}$`}
                                   errorMsg={msg.settings.deviceName.error}
                                   onClose={this.closeDeviceNameKeyboardOpen}
                                   onSubmit={this.submitDeviceNameKeyboardOpen}
                                   label={msg.settings.deviceName.keyboardName}/>
                    }

                    {settingTab === TAB_SELL &&
                    <div className="table">
                        <div className="table-body view-full">
                            <ChangeOffer/>
                            <Homepage/>
                            <PaymentSelect/>
                        </div>
                    </div>
                    }

                    {settingTab === TAB_SYSTEM &&
                    <div className="table">
                        <div className="table-body view-full">
                            {isEnv(['electron', 'web_desktop']) &&
                            <Mouse/>
                            }
                            <LoginByPin/>
                            <PinLockTimeout openPopup={this.openPinChoosePopup}/>
                            {isEnv(['electron']) && <FullScreen/>}
                            <Language/>
                            <DeviceName openKeyboard={this.openDeviceNameKeyboardOpen}/>
                            <SendLocalestorage />
                        </div>
                    </div>
                    }

                    {settingTab === TAB_PRINT &&
                    <div className="table">
                        {isEnv(['electron']) && typeof window.parent.Ocellot === 'undefined' && <SilentPrint/>}
                        {isEnv(['android_app', 'electron']) && typeof window.parent.Ocellot !== 'undefined' &&
                        <PrintType openPopup={this.openPrintTypePopup}/>}
                        {isEnv(['android_app', 'electron']) && typeof window.parent.Ocellot !== 'undefined' &&
                        <PrintTest/>}

                        {isEnv(['android_app', 'electron']) && typeof window.parent.Ocellot !== 'undefined' &&
                        <BillPrintOff/>}

                        {isEnv(['electron']) && typeof window.parent.Ocellot === 'undefined' && <KitchenPrint/>}
                        {isEnv(['android_app', 'electron']) && typeof window.parent.Ocellot !== 'undefined' &&
                        <SelectKitchenPrint openPopup={this.openKitchenPrintTypePopup}/>}
                        {isEnv(['android_app', 'electron']) && typeof window.parent.Ocellot !== 'undefined' &&
                        <KitchenPrintItemStyle/>}
                        {isEnv(['android_app', 'electron']) && typeof window.parent.Ocellot !== 'undefined' &&
                        <KitchenPrintTest/>}
                    </div>
                    }
                </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    offers: state.offers.get('offers'),
    bar: state.bars.get('bar'),
    deviceId: state.device.get('id'),
    logoutTimerOptions: state.device.get('logoutTimerOptions'),
    kitchenPrintLength: state.device.get('kitchenPrintLength'),
    printLength: state.device.get('printLength'),
    printTypeOptions: state.device.get('printTypeOptions'),
    kitchenPrintTypeOptions: state.device.get('kitchenPrintTypeOptions'),
    kitchenPrintType: state.device.get('kitchenPrintType'),
    printType: state.device.get('printType'),
    showButtonLock: state.users.get('showButtonLock'),
    deviceName: state.device.name,
    currentPrintAddress: state.device.printAddress,
    currentKitchenPrintAddress: state.device.kitchenPrintAddress
}), {
    chooseOffer, showPopupInMenu, fetchOnlyCategories, changeDeviceSettings, doNonUserWithPinError, setDeviceName
})(Settings);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/Settings.js